import { render, staticRenderFns } from "./admin-aoi-list-item.vue?vue&type=template&id=fa79889c&scoped=true&"
import script from "./admin-aoi-list-item.vue?vue&type=script&lang=js&"
export * from "./admin-aoi-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa79889c",
  null
  
)

export default component.exports